import { render } from "./c_Products.vue?vue&type=template&id=c4930322&scoped=true"
import script from "./c_Products.vue?vue&type=script&lang=js"
export * from "./c_Products.vue?vue&type=script&lang=js"

import "./c_Products.vue?vue&type=style&index=0&id=c4930322&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4930322"]])

export default __exports__